
const domLoadComponents = () => {
  console.log('domLoad:components');

  // instantiate

  // run

};

export default domLoadComponents;
